import React, { Component } from 'react';
import {
    Grid,
    Button,
    Card,
    CardContent
} from '@mui/material'
import {
    ArrowLeft as GoBack
} from 'react-feather'
import moment from 'moment';

class ShowHistory extends Component {
    constructor() {
        super();
    }
    render() {
        return (
            <>
                <Grid container
                    sx={{
                        width: '100%',
                        p: 3,
                        fontFamily: 'sans-serif'
                    }}
                >
                    <Grid item xs={12}>
                        <Button sx={{
                            px: 3,
                            mt: { xs: 2, sm: 0 },
                            fontSize: 14,
                            mb: 3
                        }}
                            startIcon={<GoBack size={"18"} />}
                            onClick={() => this.props.handleHideHistorySection()}
                        > Back</Button>
                    </Grid>
                    <Grid item xs={12}
                        sx={{
                            color: '#050A4E',
                            fontWeight: 600,
                            mb: 1,
                            ml: 2,
                            fontSize: 16
                        }}
                    >
                        Order Details
                    </Grid>
                    <Grid item xs={12}
                        sx={{
                            mb: 3,
                            fontSize: 14
                        }}
                    >
                        <Grid container
                            sx={{
                                width: '100%',
                                borderTopLeftRadius: 24,
                                borderTopRightRadius: 24,
                                borderBottom: '1px solid #BDBDBD',
                                p: 2,
                                pl: 4,
                                boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.06)',
                                background: '#F0F0F0'
                            }}
                        >
                            <Grid item xs={3}>
                                <div className='orderHeaderTitle' >Order Placed</div>
                                <div className='ohd-value'>{this.props.appointment?.orderPlaced ? moment(this.props.appointment.orderPlaced).format('DD MMM YYYY') : '-'}</div>
                            </Grid>
                            <Grid item xs={3}>
                                <div className='orderHeaderTitle'>Order ID</div>
                                <div className='ohd-value'>{this.props.appointment?.orderId}</div>
                            </Grid>
                            <Grid item xs={3}>
                                <div className='orderHeaderTitle'>Order Placed For</div>
                                <div className='ohd-value'>{this.props.appointment?.orderPlacedFor}</div>
                            </Grid>
                            <Grid item xs={3}>
                                <div className='orderHeaderTitle'>Mobile Number</div>
                                <div className='ohd-value'>{this.props.appointment?.phoneNumber}</div>
                            </Grid>
                        </Grid>
                        <Card sx={{
                            width: '100%',
                            borderBottomLeftRadius: 24,
                            borderBottomRightRadius: 24,
                            pl: 2
                        }}>
                            <CardContent>
                                {
                                    this.props.orderHistory?.map((history, idx) => {
                                        return (
                                            <>
                                                <div>
                                                    <span className='h-header'>
                                                        {history?.date ? moment(history.date).format("DD-MM-YYYY") : null}
                                                        {history?.date ? <span>    |    </span> : null}
                                                        {history?.date ? moment(history.date).format("hh:mm A") : null}
                                                    </span>
                                                </div>
                                                {
                                                    idx == 0 ? (
                                                        [86, 87, 169, 57].includes(history?.statusId) ?
                                                            <div className='h-status od-deliveredStatus'>{history?.status}</div> :
                                                            ([27, 28, 43, 5].includes(history?.statusId) ?
                                                                <div className='h-status od-cancelStatus'>{history?.status}</div> :
                                                                <div className='h-status od-otherStatus'>{history?.status}</div>)
                                                    ) : <div className='h-status'>{history?.status}</div>
                                                }
                                            </>

                                        )
                                    })
                                }
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </>
        );
    }
}

export default ShowHistory;